/* global navigator, RTCSessionDescription, RTCIceCandidate, RTCPeerConnection */
import { connect } from 'react-redux'
import * as Jsx from './rxCallScreen.jsx'
import { initializeApp } from "firebase/app"
import { getDatabase, ref, set } from "firebase/database"
const getStats = require('getstats')

// const { rxsetLocal, rxgetLocal } = global.rootRequire('classes/request')
const RxComponent = global.rootRequire('components/shares/rxComponent').default
const { rxaget, secondsToTime ,changeColorSVG} = global.rootRequire('classes/ulti')

const { netaCallHistoryUpdate, changeStatusTabmore } = global.rootRequire('redux')
const rxio = global.rootRequire('classes/socket').default
const chatDB = global.rootRequire('classes/indexedDB').default

//const iceServers = {
//  iceServers: [{
//    urls: ['turn:turn.hura.asia:3478'],
//    username: 'developer',
//    credential: 'password'
//  }, {
//    urls: ['stun:turn.hura.asia:3478'],
//    username: 'developer',
//    credential: 'password'
//  }]
//}

//const iceServers = {
//	iceServers: [{
//		urls: ['turn:turn.bobacu.io:3478'],
//		username: 'turnuser',
//		credential: 'turn456'
//	}],
//	iceTransportPolicy : "relay"
//}
const iceServers = [
	{ urls: "stun:stun.l.google.com:19302" },
	{ urls: "stun:stun.l.google.com:5349" },
	{ urls: "stun:stun1.l.google.com:3478" },
	{ urls: "stun:stun1.l.google.com:5349" },
	{ urls: "stun:stun2.l.google.com:19302" },
	{ urls: "stun:stun2.l.google.com:5349" },
	{ urls: "stun:stun3.l.google.com:3478" },
	{ urls: "stun:stun3.l.google.com:5349" },
	{ urls: "stun:stun4.l.google.com:19302" },
	{ urls: "stun:stun4.l.google.com:5349" }
];

let mediaConstraints = {
  audio: true,
  video: true,
}

let flagCall = 0

class CallScreenComponent_ extends RxComponent {
  constructor(props, context) {
    super(props, context, Jsx)
    this.state = {
      group: rxaget(this.props, 'group', {}),

      flagCalling: false,
      ringtone: false,
      flagStartCall: false,
      isStarted: false,
      flagMic: true,
      flagCamera: false,
      flagShowDebug: false,
      flagShareScreen: false,
      flagSourceScreen: false,
      flagError: false,
      remoteStream: {},
      localStream: {},

      audioinput: [],
      audiooutput: [],
      videoinput: [],
      audioinputDefault: '', 
      audiooutputDefault: '', 
      videoinputDefault: '',
      flagShowSetting: false,

      descAlertCall: 0, //0: Contacting, 1: Ringing, 2: Is Calling, 3: Connecting

      seconds: 0,
      time: {h:'00',m:'00',s:'00'},
      flagEnding:false
    }

    this.userid = rxaget(this.props, 'netaauth.user.id', '')
    this.token = rxaget(this.props, 'netaauth.user.token', '')
    this.users = rxaget(this.props, 'user.users', {}) || {}
    this.type = rxaget(this.props, 'type', '')

    this.localStream = null
    this.remoteStream = null
    this.rtcPeerConnection = null
    this.shareScreenStream = null
    this.timer = null
    this.timeoutCounter = null
    this.secondsCounter = 0
    
    this.isRoomCreator = false
    
    this.callObj = {}

    this.remoteUser = {}

    this.setRemoteStream = this.setRemoteStream.bind(this)
    this.sendIceCandidate = this.sendIceCandidate.bind(this)
    this.sendConnected = this.sendConnected.bind(this)

    this.gotDevices =  this.gotDevices.bind(this)
    this.changeDeviceAudioOutput = this.changeDeviceAudioOutput.bind(this)
    this.changeDeviceAudioInput = this.changeDeviceAudioInput.bind(this)

    try {
      console.log('Init GetDevice ------')
      navigator.mediaDevices.enumerateDevices().then(this.gotDevices).catch((error) => {
        console.log('navigator.MediaDevices.getUserMedia error: ', error.message, error.name);
      })
    } catch(e) {}
  }

  componentDidMount() {
    this.loadDidMount()
  }

  checkConnectSocket(args) {
    if (rxio.flaglogin) {
      this.onClickStartCall(args.typecall, args.grouptmp)
    } else {
      setTimeout(() => {
        this.checkConnectSocket(args)  
      }, 300)
    }
  }

  loadDidMount() {
    if (this.token && this.userid) {
      if (!rxio.connected && !rxio.init_connected) {
        rxio.login(this.token, this.userid, (data) => {
          this.loadHandleSocket()  
        })
      } else {
        this.loadHandleSocket()
      }
    }

    if (window && window.ipcRenderer) {
      window.ipcRenderer.on('configs_call', (event, args) => {
        setTimeout(() => {
          // window.ipcRenderer.send('log_call', {type: 'configs_call_01', data: {args: args, connected: rxio.connected}})
          this.checkConnectSocket(args)
        }, 300)
      })

      window.ipcRenderer.on('start_call_screen', (event, args) => {
        // window.ipcRenderer.send('log_call', {type: 'start_call_screen_01', data: args})
        setTimeout(async () => {
          let data = args
          if (!this.state.flagCalling) {
            // Load local Stream First
            try {
              this.callObj = rxaget(data, 'call', {})

              try {
                console.log('Init GetDevice When Receive Call ------')
                navigator.mediaDevices.enumerateDevices().then(this.gotDevices).catch((error) => {
                  console.log('navigator.MediaDevices.getUserMedia error: ', error.message, error.name);
                })
              } catch(e) {}

              let remote_uin = rxaget(global.rxu.array(rxaget(this.callObj, 'callee_uins', [])).filter(ele => (ele !== this.userid.toString())), '0', '')
              if (remote_uin) {
                let remoteUser = await chatDB.users.get(Number(remote_uin))
                if (remoteUser && (remoteUser.full_name || remoteUser.phone)) {
                  this.remoteUser = remoteUser
                  // window.ipcRenderer.send('log_call', {type: 'start_call_screen_02', data: remoteUser})
                } else {
                  try {
                    if (rxaget(this.callObj, 'group_id', '')) {
                      let objUsers = []
                      let group_id = rxaget(this.callObj, 'group_id', '')
                      const api_group_detail = global.rxu.config.get_groups + '/' + group_id 
            
                      let res = await fetch(api_group_detail, { method: 'GET', headers: { Accept: 'application/json', 'TC-Token': this.token, Connection: 'Keep-Alive', 'Accept-Encoding': 'gzip' }, body: null })
                      let json = await res.json()
                    
                      if (json) {
                        if (json.users && json.users.constructor === Array && json.users.length > 0) {
                          for (const user of json.users) {
                            objUsers.push({ id: user.Id, uid: user.Id,  ...user })  
                          }
                        }
                        if (json.Group && json.Group.group_id.toString() === group_id.toString()) {
                          chatDB.users.bulkPut(objUsers)
                        }
                        let findUser= objUsers.find((u) => Number(u.Id) === Number(remote_uin))
                    
                        if (findUser && findUser.phone) {
                          this.remoteUser = findUser
                        }
                        // window.ipcRenderer.send('log_call', {type: 'start_call_screen_03', data: findUser})
                      }
                    }
                  } catch(e) {}
                }
              }         
              // window.ipcRenderer.send('log_call', {type: 'start_call_screen_04', data: this.remoteUser})
              let arrAudioInput = this.state.audioinput
              if (arrAudioInput.length > 0) {
                this.setState({flagCalling: true, ringtone: true, descAlertCall: 2}, async () => {
                  this.localVideoComponent = document.getElementById('local-video-screen')
                  this.remoteVideoComponent = document.getElementById('remote-video-screen')
  
                  this.localAudioComponent = document.getElementById('local-audio-screen')
                  this.remoteAudioComponent = document.getElementById('remote-audio-screen')
  
                  this.setLocalStream(mediaConstraints, this.callObj.media_type)
                  this.startTimeoutCounter()
                })
              } else {
                this.setState({flagCalling: true, flagError: true, ringtone: false}) 
              }
              
            } catch(e) {}
          }
        }, 1000)
      })

      window.ipcRenderer.on('close_call_screen', (event, args) => {
        this.onClickStopCall()
      })
    }
  }

  loadHandleSocket() {
    rxio.getWaitConnect((data) => {
      if (rxio.connected) {
        rxio.socket.on('event', async (data) => {
          if (data.type === 4) {
            this.setState({descAlertCall: 1})
          }
          if (data.type === 5) {
            if (this.state.flagStartCall && this.callObj && this.callObj.media_type && this.callObj.media_type === 1) {
              await this.changeDevice()
              this.setState({flagCamera: true}, () => {
                if (window && window.ipcRenderer) {
                  window.ipcRenderer.send('changesize_videocall', {type: 'videocall'})  
                }
                if (this.state.flagStartCall && this.callObj && this.callObj.media_type) {
                  const receiverUin = (this.userid.toString() === rxaget(data, 'sender_uin', "")) ? rxaget(data, 'receiver_uin', "") : this.userid.toString()
                  rxio.socket.emit('event', {
                    group_id: rxaget(data, 'group_id', ''),
                    sender_uin: this.userid,
                    receiver_uin: Number(receiverUin),
                    type: 7
                  }, (data1) => {})  
                }
              })
            }
          }

          if (data.type === 6) {
            if (window && window.ipcRenderer) {
              window.ipcRenderer.send('changesize_videocall', {type: 'voicecall'})  
            }
          }

          if (data.type === 7) {
            if (this.state.flagStartCall && this.callObj && this.callObj.media_type && this.callObj.media_type === 1) {
              await this.changeDevice()

              if (window && window.ipcRenderer) {
                window.ipcRenderer.send('changesize_videocall', {type: 'videocall'})  
              }

              const receiverUin = (this.userid.toString() === rxaget(data, 'sender_uin', "")) ? rxaget(data, 'receiver_uin', "") : this.userid.toString()
              rxio.socket.emit('event', {
                group_id: rxaget(data, 'group_id', ''),
                sender_uin: this.userid,
                receiver_uin: Number(receiverUin),
                type: 7
              }, (data1) => {}) 
            }      
          }

          if (data.type === 8) {
            rxio.sendCallAvailableAnswer({
              group_id: rxaget(data, 'group_id', ""),
              sender_uid: rxaget(data, 'sender_uin', ""),
              receiver_uin: rxaget(data, 'receiver_uin', ""),
              type: 2
            })
          }

          if (data.type === 9) {
          }

          if (data.type === 10) {
            // if (this.call_id) {
            //   rxio.socket.emit('call_status', { group_id: data.group_id, call_id: this.call_id }, (data) => {
            //     if (data.status === 1 && data.result === 0) {
            //       this.setState({ call_answer: true })
            //       const receiverUin = global.rxu.get(global.rxu.array(this.state.objsCalling.callee_uins).filter(ele => (ele !== this.userid)), [0])
            //       rxio.socket.emit('event', {
            //         group_id: data.group_id,
            //         sender_uin: this.userid.toString(),
            //         receiver_uin: receiverUin,
            //         type: 4,
            //         data: ''
            //       }, (data1) => {})
            //       rxio.socket.emit('event', {
            //         group_id: data.group_id,
            //         sender_uin: this.userid.toString(),
            //         receiver_uin: receiverUin,
            //         type: 8,
            //         data: ''
            //       }, (data2) => {})
            //     }
            //   })
            // }
          }
        })

        // Nhận cuộc gọi
        // rxio.socket.on('start_call', async (data) => {
        // })

        // Nhận offer
        rxio.socket.on('ice_sdp', async (event) => {
          // console.log('Socket event callback: offer')
          try {
            if (this.state.flagStartCall) {
              if (event.sdp) {
                if (!this.isRoomCreator) {
                  this.rtcPeerConnection = new RTCPeerConnection(iceServers)
                  
                  var repeatInterval = 2000; // 2000 ms == 2 seconds
                  getStats(this.rtcPeerConnection, (result) => {
                    this.previewGetStatsResult(this.rtcPeerConnection, result)
                  }, repeatInterval);

                  this.addLocalTracks(this.rtcPeerConnection)
                  this.rtcPeerConnection.ontrack = this.setRemoteStream
                  this.rtcPeerConnection.onicecandidate = this.sendIceCandidate
                  this.rtcPeerConnection.onconnectionstatechange = this.sendConnected
                  this.rtcPeerConnection.oniceconnectionstatechange = (ev) => {
                      if (this.rtcPeerConnection.iceConnectionState === 'failed' && flagCall < 5) {
                        flagCall += 1
                        this.rtcPeerConnection.restartIce()
                      }
                    }
                  this.rtcPeerConnection.setRemoteDescription(new RTCSessionDescription({type: 'offer', sdp: event.sdp }))

                  this.rtcPeerConnection.onaddstream = function (e) { 
                    if (this.remoteAudioComponent) {
                      this.remoteAudioComponent.srcObject = e.stream
                      this.remoteStream = e.stream    
                    } else {
                      this.remoteAudioComponent = document.getElementById('remote-audio-screen')  
                      this.remoteAudioComponent.srcObject = e.stream
                      this.remoteStream = e.stream
                    }
                  }

                  await this.createAnswer(this.rtcPeerConnection)
                } else {
                  if (this.rtcPeerConnection) {
                    this.rtcPeerConnection.setRemoteDescription(new RTCSessionDescription({type: 'answer', sdp: event.sdp }))  
                  } 
                }  
              }  
            } else {
              this.stopStream()
            }
            
          } catch(e) {}
        })

        // Nhận answer
        rxio.socket.on('answer_call', (event) => {
          // console.log('Socket event callback: webrtc_answer')
          if (this.callObj && this.callObj.callee_uins && this.callObj.callee_uins.constructor === Array && this.callObj.callee_uins.length === 2) {
            let mediaConstraints = (this.callObj.media_type === 1) ? {audio: true} : {video: true, audio: true} 
      
            navigator.mediaDevices.getUserMedia(mediaConstraints).then( (stream) => {
              this.localStream = stream
              this.localVideoComponent.srcObject = stream
              this.localAudioComponent.srcObject = stream
              
              if (this.callObj && this.callObj.media_type && this.callObj.media_type === 2) {
                if (window && window.ipcRenderer) {
                  window.ipcRenderer.send('changesize_videocall', {type: 'videocall'})  
                }
              }
    
              try {
                this.setState({isStarted: true, ringtone: false, flagStartCall: true}, async () => {
                  if (this.isRoomCreator) {
                    this.rtcPeerConnection = new RTCPeerConnection(iceServers)
                    
                    var repeatInterval = 2000; // 2000 ms == 2 seconds
                    getStats(this.rtcPeerConnection, (result) => {
                      this.previewGetStatsResult(this.rtcPeerConnection, result)
                    }, repeatInterval);
    
                
                    this.addLocalTracks(this.rtcPeerConnection)
                    this.rtcPeerConnection.ontrack = this.setRemoteStream
                    this.rtcPeerConnection.onicecandidate = this.sendIceCandidate
                    this.rtcPeerConnection.onconnectionstatechange = this.sendConnected
              
                    await this.createOffer(this.rtcPeerConnection)  
                    this.startTimer()            
                  }  
                })
              } catch(e) {
                console.log(e)
              }
            }).catch((e) => { console.log(e) })
          }
        })

        // Nhận stop call
        rxio.socket.on('stop_call', (event) => {
          this.stopStream()  
        })

        // Nhan Candidate
        rxio.socket.on('ice_candidate', (event) => {
          // console.log('Socket event callback: webrtc_ice_candidate')
          // ICE candidate configuration.
          if (this.state.flagStartCall) {
            try {
              var candidate = new RTCIceCandidate({
                sdpMid: event.sdp_mid,
                sdpMLineIndex: event.sdp_mline_index,
                candidate: event.candidate,
              })
              if (this.rtcPeerConnection) {
                this.rtcPeerConnection.addIceCandidate(candidate)  
              }
            } catch(e) {}  
          } else {
            this.stopStream()
          }
        })    
      } else {
        setTimeout(() => {
          this.loadHandleSocket()  
        }, 300)
      }
    })
  }

  // Replace Track
  async changeDevice() {
    try {
      try {
        if (this.localStream) {
          const tracks =  this.localStream.getTracks()
          tracks.forEach(function (track) { track.stop() })
          this.localStream = null  
        }
      } catch(e) {}

      navigator.mediaDevices.getUserMedia({ audio: true, video: true })
      .then(async (stream) => {
        const tracks = stream.getTracks()
        let videoTrack = stream.getVideoTracks()[0];
        this.rtcPeerConnection.getSenders()
          .forEach(async (sender) => {
            if (sender && sender.track) {
              const newTrack = tracks.find(track => track.kind === sender.track.kind)
              this.rtcPeerConnection.removeTrack(sender)

              try {
                this.localStream = stream
                this.localVideoComponent.srcObject = stream
              } catch(e) {}
              const newSender = this.rtcPeerConnection.addTrack(videoTrack, stream)
            }
          })
      })
    } catch(e2) {}  
  }

  // Gọi đi
  async onClickStartCall(type, grouptmp) { 
    // window.ipcRenderer.send('log_call', {type: 'configs_call_02', data: grouptmp})
    try {
      console.log('Init GetDevice When Start Call ------')
      navigator.mediaDevices.enumerateDevices().then(this.gotDevices).catch((error) => {
        console.log('navigator.MediaDevices.getUserMedia error: ', error.message, error.name);
      })
    } catch(e) {}

    type = type || 2
    this.isRoomCreator = true
    let arrUser = rxaget(grouptmp, 'occupants_uins', [])
    if (arrUser.length === 2) {
      let remoteUser = arrUser.filter(uid => uid !== this.userid)[0]

      let remote_uin = rxaget(global.rxu.array(arrUser).filter(ele => (ele !== this.userid.toString())), '0', '')
      if (remote_uin) {
        remoteUser = await chatDB.users.get(Number(remote_uin))
        if (remoteUser && (remoteUser.full_name || remoteUser.phone)) {
          this.remoteUser = remoteUser
        } else {
          try {
            if (rxaget(grouptmp, 'group_id', '')) {
              let objUsers = []
              let group_id = rxaget(grouptmp, 'group_id', '')
              const api_group_detail = global.rxu.config.get_groups + '/' + group_id 
              let res = await fetch(api_group_detail, { method: 'GET', headers: { Accept: 'application/json', 'TC-Token': this.token, Connection: 'Keep-Alive', 'Accept-Encoding': 'gzip' }, body: null })
              let json = await res.json()

              if (json) {
                if (json.users && json.users.constructor === Array && json.users.length > 0) {
                  for (const user of json.users) {
                    objUsers.push({ id: user.Id, uid: user.Id,  ...user })  
                  }
                }
                if (json.Group && json.Group.group_id.toString() === group_id.toString()) {
                  chatDB.users.bulkPut(objUsers)
                }
                let findUser= objUsers.find((u) => Number(u.Id) === Number(remote_uin))
                if (findUser && findUser.phone) {
                  this.remoteUser = findUser
                  remoteUser = findUser
                }
              }
            }
          } catch(e) {}
        }
      }

      // window.ipcRenderer.send('log_call', {type: 'configs_call_03', data: remoteUser})

      if(remoteUser !== '' && remoteUser !== this.userid){
        let ele = grouptmp || {}
        ele.callee_uins = arrUser.filter(uid => uid.toString() !== this.userid.toString())
        ele.caller_uin = this.userid
        ele.media_type = type

        let arrAudioInput = this.state.audioinput
        if (arrAudioInput.length > 0) {
          // window.ipcRenderer.send('log_call', {type: 'configs_call_04', data: ele})
          rxio.createCall(ele, (data) => {
            // Load local Stream First
            this.callObj = rxaget(data, 'call', {})
            // window.ipcRenderer.send('log_call', {type: 'configs_call_05', data: this.callObj})
            
            this.setState({flagCalling: true, ringtone: true}, async () => {
              this.localVideoComponent = document.getElementById('local-video-screen')
              this.remoteVideoComponent = document.getElementById('remote-video-screen')
  
              this.localAudioComponent = document.getElementById('local-audio-screen')
              this.remoteAudioComponent = document.getElementById('remote-audio-screen')
  
              this.setLocalStream(mediaConstraints, this.callObj.media_type)
  
  
              this.startTimeoutCounter()
  
              // setTimeout(() => { if (!this.state.isStarted) { this.onClickStopCall() } }, 30000)
            })
          })
        } else {
          this.setState({flagCalling: true, flagError: true}) 
        }
 
        

      } else {
        console.log('Remote user not exist')
      }
    } 
  }

  // Chấp nhận cuộc gọi
  acceptCall() {
    if (this.callObj && this.callObj.callee_uins && this.callObj.callee_uins.constructor === Array && this.callObj.callee_uins.length === 2) {
      let mediaConstraints = (this.callObj.media_type === 1) ? {audio: true} : {video: true, audio: true} 
      navigator.mediaDevices.getUserMedia(mediaConstraints).then( (stream) => {
        //Display the video stream in the video object
        this.localStream = stream
        this.localVideoComponent.srcObject = stream
        this.localAudioComponent.srcObject = stream

        rxio.socket.emit('answer_call', {
          group_id: rxaget(this.callObj, 'group_id', ''),
          call_id: rxaget(this.callObj, 'call_id', ''),
          callee_uin: this.userid.toString(),
          answer: 1
        }, () => {})
      
        if (this.callObj && this.callObj.media_type && this.callObj.media_type === 2) {
          if (window && window.ipcRenderer) {
            window.ipcRenderer.send('changesize_videocall', {type: 'videocall'})  
          }
        }
              
        this.setState({ringtone: false, flagStartCall: true, isStarted: true}, () => {
          this.startTimer()
        })
      }).catch((e) => { console.log(e) })       
    }
  }

  stopStream(configParams) {
    window.ipcRenderer.send('log_call', {type: 'stop_configs_call_01', data: configParams})
    this.stoppedCallObj = { ...this.callObj }
    try {
      clearInterval(this.timer)  
      this.timer = null
    } catch(e) {}

    try {
      if (this.localStream) {
        const tracks =  this.localStream.getTracks()
        tracks.forEach(function (track) { track.stop() })
        this.localStream = null  
      }
    } catch(e) {}

    try {
      if (this.remoteStream) {
        const remotetracks =  this.remoteStream.getTracks()
        remotetracks.forEach(function (track) { track.stop() })
        this.remoteStream = null  
      }
    } catch(e) {}

    try {
      if (this.shareScreenStream) {
        const screenTrack = this.shareScreenStream.getVideoTracks()[0]
        if (screenTrack) {
          screenTrack.stop()
        }
      }
    } catch(e) {}
    
    if (this.rtcPeerConnection) {
      this.rtcPeerConnection.close() 
      this.rtcPeerConnection = null
      if (this.stoppedCallObj) {
        this.stoppedCallObj.rtcPeerConnection = true
      }
    } else {
      if (this.stoppedCallObj) {
        this.stoppedCallObj.rtcPeerConnection = false
      }
    }


    this.isRoomCreator = false
    this.callObj = {}

    this.stopTimeoutCounter()

    this.setState({flagEnding: true, ringtone: false, flagError: false, seconds: 0, flagMic: true, flagCamera: false, flagShareScreen: false, time: {h:'00',m:'00',s:'00'}, descAlertCall: 0 })
    let stoppedCallObj = {...this.stoppedCallObj}
    setTimeout(() => {
      this.setState({flagEnding:false, ringtone: false, flagError: false, flagCalling: false, flagStartCall: false, isStarted: false, seconds: 0, flagMic: true, flagCamera: false, flagShareScreen: false, time: {h:'00',m:'00',s:'00'}, descAlertCall: 0 }, () => {
        if (window && window.ipcRenderer) {
          window.ipcRenderer.send('log_call', {type: 'stop_configs_call_02', data: stoppedCallObj})
          window.ipcRenderer.send('stop_call', stoppedCallObj || {})  
        }
      })
    }, 2000)
  }

  // Kết thục cuộc gọi
  onClickStopCall() {
    const params = {
      group_id: rxaget(this.callObj, 'group_id', ''),
      uin: this.userid,
      call_id: rxaget(this.callObj, 'call_id', ''),
    }
    

    try {
      if (!this.state.flagStartCall) {
        // const receiverUin = global.rxu.array(rxaget(this.callObj, 'callee_uins', [])).filter(ele => (ele !== this.userid.toString()))[0]

        let paramsupdate = {
          group_id: rxaget(this.callObj, 'group_id', ''),
          message_id: rxaget(this.callObj, 'message_id', ''),
          message: '',
          status: 2
        }
        rxio.updateMessage(paramsupdate, (dataMsg1) => {       
        })

        paramsupdate['status'] = 3
        rxio.updateMessage(paramsupdate, (dataMsg2) => {})

        rxio.socket.emit('event', {
          group_id: rxaget(this.callObj, 'group_id', ''),
          sender_uin: this.userid,
          type: 9
        }, (data1) => {})
        rxio.socket.emit('event', {
          group_id: rxaget(this.callObj, 'group_id', ''),
          sender_uin: this.userid,
          type: 10
        }, (data1) => {})  
      }
    } catch(e) {}

    
    rxio.stopCall(params, (data) => {})
    window.ipcRenderer.send('log_call', {type: 'stop_configs_call_03', data: params})
    setTimeout(() => {
      rxio.disconnect()
    }, 100)
    setTimeout(() => {
      this.stopStream(params)
    }, 500)

    try {
      if (this.type === 'callfunc') {
        this.props.stopCall()  
      } 
    } catch(e) {
      console.log(e)
    }
    
  }

  // Count time
  startTimer() {
    this.stopTimeoutCounter()
    setTimeout(() => {
      if (this.state.seconds === 0) {
        this.timer = setInterval(() => {this.countUp()}, 1000)
      }
    }, 1000)
  }

  countUp() {
    let seconds = this.state.seconds + 1;
    this.setState({
      time: secondsToTime(seconds),
      seconds: seconds,
    })
  }

  startTimeoutCounter() {
    setTimeout(() => {
      if (this.secondsCounter === 0) {
        this.timeoutCounter = setInterval(() => {
          this.secondsCounter += 1

          if (this.secondsCounter > 30) {
            this.onClickStopCall()
          }
        }, 1000)
      }
    }, 1000)
  }

  stopTimeoutCounter() {
    try {
      clearInterval(this.timeoutCounter)
      this.timeoutCounter = null
    } catch(e) {
      console.log(e)
    }  

    this.secondsCounter = 0
  }

  getAvatar(e, user) {
    if (user.profile_url) {
      e.target.src=global.rxu.config.get_static + user.profile_url  
    } else {
      e.target.src='./images/default/static/avadefault.svg'
    }
  }

  // Fuction Handle Stream
  setLocalStream(mediaConstraints, type) {
    let stream
    try {
      navigator.permissions.query({name: 'microphone'}).then((permissionObj) => {
        if (permissionObj.state === 'denied') {
          alert('This app don\'t currently have permission to access your microphone. Allow this app to access your microphone.')
        }
      }).catch((error) => {})

      navigator.permissions.query({name: 'camera'}).then((permissionObj) => {
        if (permissionObj.state === 'denied') {
          alert('This app don\'t currently have permission to access your camera. Allow this app to access your camera.')
        }
      }).catch((error) => {})

      if (type === 1) {
        mediaConstraints['video'] = false  
      } else {
        mediaConstraints['video'] = true
      }

    } catch (error) {
      console.error('Could not get user media', error)
    }

  }

  addLocalTracks(rtcPeerConnection) {
    try {
      if (this.localStream) {
        this.localStream.getTracks().forEach((track) => {
          rtcPeerConnection.addTrack(track, this.localStream)
        })  
      }
    } catch(e) {}
  }

  async createOffer(rtcPeerConnection) {
    let sessionDescription
    try {
      sessionDescription = await rtcPeerConnection.createOffer()
      rtcPeerConnection.setLocalDescription(sessionDescription)
    } catch (error) {
      console.error(error)
    }

    let sender_uin = this.userid.toString()
    rxio.sendIceSdp({
      group_id: rxaget(this.callObj, 'group_id', ''),
      call_id: rxaget(this.callObj, 'call_id', ''),
      sender_uin: sender_uin,
      receiver_uin: global.rxu.array(rxaget(this.callObj, 'callee_uins', [])).filter(ele => (ele !== sender_uin))[0],
      type: 1,
      sdp: sessionDescription.sdp
    })
  }

  async createAnswer(rtcPeerConnection) {
    let sessionDescription
    try {
      sessionDescription = await rtcPeerConnection.createAnswer()
      rtcPeerConnection.setLocalDescription(sessionDescription)
    } catch (error) {
      console.error(error)
    }

    let sender_uin = this.userid.toString()
    rxio.sendIceSdp({
      group_id: rxaget(this.callObj, 'group_id', ''),
      call_id: rxaget(this.callObj, 'call_id', ''),
      sender_uin: sender_uin,
      receiver_uin: global.rxu.array(rxaget(this.callObj, 'callee_uins', [])).filter(ele => (ele !== sender_uin))[0],
      type: 2,
      sdp: sessionDescription.sdp
    })

    // rxio.socket.emit('event', {
    //   group_id: rxaget(this.callObj, 'group_id', ''),
    //   sender_uin: sender_uin,
    //   receiver_uin: global.rxu.array(rxaget(this.callObj, 'callee_uins', [])).filter(ele => (ele !== sender_uin))[0],
    //   type: 11
    // }, (data1) => {})

    // rxio.socket.emit('call_event', {
    //   group_id: rxaget(this.callObj, 'group_id', ''),
    //   call_id: rxaget(this.callObj, 'call_id', ''),
    //   event: 2
    // }, (data) => {})
  }

  setRemoteStream(event) {
    try {
      if (this.remoteVideoComponent) {
        this.remoteVideoComponent.srcObject = event.streams[0]
        this.remoteStream = event.stream    
      }
    } catch(e) {}
  }

  sendIceCandidate(event) {
    if (event.candidate) {
      let sender_uin = this.userid.toString()
      rxio.sendIceCandidate({
        call_id: rxaget(this.callObj, 'call_id', ''),
        group_id: rxaget(this.callObj, 'group_id', ''),
        receiver_uin: global.rxu.array(rxaget(this.callObj, 'callee_uins', [])).filter(ele => (ele !== sender_uin))[0],
        sdp_mline_index: event.candidate.sdpMLineIndex,
        sender_uin: sender_uin,
        candidate: event.candidate.candidate
      })
    }
  }

  sendConnected(event) {
    if (this.rtcPeerConnection && this.rtcPeerConnection.connectionState === 'connected') {
      let sender_uin = this.userid.toString()
      rxio.socket.emit('event', {
        group_id: rxaget(this.callObj, 'group_id', ''),
        sender_uin: Number(sender_uin),
        receiver_uin: global.rxu.array(rxaget(this.callObj, 'callee_uins', [])).filter(ele => (ele !== sender_uin))[0],
        type: 11
      }, (data1) => {})

      rxio.socket.emit('call_event', {
        group_id: rxaget(this.callObj, 'group_id', ''),
        call_id: rxaget(this.callObj, 'call_id', ''),
        event: 2
      }, (data) => {})
    }

    if (this.rtcPeerConnection.connectionState === 'failed' && flagCall < 5) {
      flagCall += 1
      this.rtcPeerConnection.restartIce()
    }
  }

  changeFlagMic() {
    let flagMic = this.state.flagMic
    this.setState({flagMic: !flagMic}, () => {
      try {
        this.localStream.getAudioTracks()[0].enabled = !flagMic
      } catch(e) {}
    })
  }

  changeFlagCamera() {
    let flagCamera = this.state.flagCamera
    this.setState({flagCamera: !flagCamera}, () => {
      if (this.state.flagStartCall && this.callObj && this.callObj.media_type === 1) {
        try {
          const receiverUin = global.rxu.array(rxaget(this.callObj, 'callee_uins', [])).filter(ele => (ele !== this.userid.toString()))[0]
          if (flagCamera) {
            rxio.socket.emit('event', {
              group_id: rxaget(this.callObj, 'group_id', ''),
              sender_uin: this.userid,
              receiver_uin: Number(receiverUin),
              type: 6
            }, (data1) => {})  
          } else {
            rxio.socket.emit('event', {
              group_id: rxaget(this.callObj, 'group_id', ''),
              sender_uin: this.userid,
              receiver_uin: Number(receiverUin),
              type: 5
            }, (data1) => {})  
          }          
        } catch(e) {}
      }
    })
  }

  onClickFullScreen() {
    try {
      if (this.state.flagStartCall && this.callObj && this.callObj.media_type === 2) {
        let elem = document.getElementById("remote-video");
        if (elem.requestFullscreen) {
          elem.requestFullscreen()
        } else if (elem.webkitRequestFullscreen) { /* Safari */
          elem.webkitRequestFullscreen()
        } else if (elem.msRequestFullscreen) { /* IE11 */
          elem.msRequestFullscreen()
        }
      }
    } catch(e) {}
  }

  closePopupShareScreen() {
    this.setState({flagSourceScreen: false}, () => {
    })
  }

  confirmSourceShareScreen(screenActiveId) {
    this.setState({flagSourceScreen: false}, () => {
      if (screenActiveId) {
        this.shareScreen(screenActiveId)  
      }
    })
  }

  onClickShareScreen() {
    let flagShareScreen = this.state.flagShareScreen
    if (this.state.flagStartCall && this.callObj && this.callObj.media_type === 2) {
      if (!flagShareScreen) {
        this.setState({flagShareScreen: true, flagSourceScreen: true}, () => {})
      } else {
        // Stop Share Screen
        this.setState({flagShareScreen: false}, () => {
          try {
            if (this.shareScreenStream) {
              const screenTrack = this.shareScreenStream.getVideoTracks()[0]
              if (screenTrack) {
                screenTrack.stop()
              }
            }
          } catch(e1) {}
          try {
            if (this.localStream) {
              this.localStream.getTracks().forEach((newTrack) => {
                this.replaceTrack(newTrack)
              })  
            }
          } catch(e) {
            console.log(e)
          }
        })
      }  
    }
  }

  async shareScreen(screenActiveId) {
    try {
      const mediaStream = await this.getLocalScreenCaptureStream(screenActiveId);

      if (mediaStream) {
        this.shareScreenStream = mediaStream

        const screenTrack = mediaStream.getVideoTracks()[0];

        if (screenTrack) {
          console.log('replace camera track with screen track');
          this.replaceTrack(screenTrack);
        } else {
          this.setState({flagShareScreen: false})
        }
      } else {
        this.setState({flagShareScreen: false})
      }
    } catch(e) {}
  }

  async getLocalScreenCaptureStream(screenActiveId) {
    try {
      const constraints = { 
        video: {
          mandatory: {
            chromeMediaSource: 'desktop',
            chromeMediaSourceId: screenActiveId,
            minWidth: 1280,
            maxWidth: 1280,
            minHeight: 720,
            maxHeight: 720
          }
        }, 
        audio: false 
      }

      const screenCaptureStream = await navigator.mediaDevices.getUserMedia(constraints)
      return screenCaptureStream
    } catch (error) {
      if (error.message && error.message.indexOf('Permission denied by system') !== -1) {
        alert('Trình duyệt này không có quyền "Screen Share". Vui lòng vào cài đặt hệ thống và cho phép quyền "Share Screen" trên trình duyệt này')
      }
    }
  }

  replaceTrack(newTrack) {
    try {
      const sender = this.rtcPeerConnection.getSenders().find(sender =>
        sender.track.kind === newTrack.kind 
      );

      if (!sender) {
        console.warn('failed to find sender');

        return;
      }

      sender.replaceTrack(newTrack);
    } catch(e) {}
  }

  gotDevices(deviceInfos) {
    console.log('DeviceInfos: %v ------', deviceInfos)
    let audioinput = [] 
    let audiooutput = [] 
    let videoinput = []
    let audioinputTmp = '' 
    let audiooutputTmp = '' 
    let videoinputTmp = ''
    let audioinputDefault = '' 
    let audiooutputDefault = '' 
    let videoinputDefault = ''
    for (let i = 0; i !== deviceInfos.length; ++i) {
      const deviceInfo = deviceInfos[i];
      let objInfo = {}
      objInfo['value'] = deviceInfo.deviceId
      if (deviceInfo.kind === 'audioinput') {
        if (deviceInfo.deviceId === 'default' && deviceInfo.label) {
          audioinputTmp = rxaget(deviceInfo, 'label', '').replace('Default - ', '')
        } else {
          objInfo['text'] = deviceInfo.label || `microphone ${audioinput.length + 1}`
          if (deviceInfo.label === audioinputTmp) {
            audioinputDefault = deviceInfo.deviceId
          }
          audioinput.push(objInfo)  
        }        
      } else if (deviceInfo.kind === 'audiooutput') {
        if (deviceInfo.deviceId === 'default' && deviceInfo.label) {
          audiooutputTmp = rxaget(deviceInfo, 'label', '').replace('Default - ', '')
        } else {
          objInfo['text'] = deviceInfo.label || `speaker ${audiooutput.length + 1}`
          if (deviceInfo.label === audiooutputTmp) {
            audiooutputDefault = deviceInfo.deviceId
          }
          audiooutput.push(objInfo)
        }        
        
      } else if (deviceInfo.kind === 'videoinput') {
        if (deviceInfo.deviceId === 'default' && deviceInfo.label) {
          videoinputTmp = rxaget(deviceInfo, 'label', '').replace('Default - ', '')
        } else {
          objInfo['text'] = deviceInfo.label || `camera ${videoinput.length + 1}`
          if (deviceInfo.label === videoinputTmp) {
            videoinputDefault = deviceInfo.deviceId
          }
          videoinput.push(objInfo)
        }        
        
      } else {
        console.log('Some other kind of source/device: ', deviceInfo)
      }
    }
    if (!audioinputTmp && audioinput.length > 0) {
      audioinputDefault = audioinput[0]['value']
    }
    if (!audiooutputTmp && audiooutput.length > 0) {
      audiooutputDefault = audiooutput[0]['value']
    }
    if (!videoinputTmp && videoinput.length > 0) {
      videoinputDefault = videoinput[0]['value']
    }
    this.setState({
      audioinput: audioinput,
      audiooutput: audiooutput,
      videoinput: videoinput,
      audioinputDefault: audioinputDefault,
      audiooutputDefault: audiooutputDefault,
      videoinputDefault: videoinputDefault
    })
  }
  attachSinkId(element, sinkId, type) {
    console.log(element)
    if (typeof element.sinkId !== 'undefined') {
      element.setSinkId(sinkId)
          .then(() => {
            console.log(`Success, audio output device attached: ${sinkId} to element with ${element.title} as source.`);
            
            if (type === 'audiooutput') {
              this.setState({
                audiooutputDefault: sinkId
              })  
            }
            
          })
          .catch(error => {
            let errorMessage = error;
            if (error.name === 'SecurityError') {
              errorMessage = `You need to use HTTPS for selecting audio output device: ${error}`;
            }
            console.error(errorMessage);
          });
    } else {
      console.warn('Browser does not support output device selection.');
    }
  }
  changeDeviceAudioInput(e) {
    let audioSource = e.target.value
    if (mediaConstraints.audio) {
      mediaConstraints.audio = {deviceId: audioSource ? {exact: audioSource} : undefined}
    }
    this.setState({
      audioinputDefault: audioSource
    }, () => {
      this.changeDeviceInput(mediaConstraints, 'audio')      
    })
    // let constraints = {
    //   audio: {deviceId: audioSource ? {exact: audioSource} : undefined},
    //   video: {deviceId: videoSource ? {exact: videoSource} : undefined}
    // };
    // navigator.mediaDevices.getUserMedia(constraints).then(gotStream).then(gotDevices).catch(handleError);
  }

  changeDeviceAudioOutput(e) {
    this.attachSinkId(this.remoteAudioComponent, e.target.value, 'audiooutput')
  }

  changeDeviceCamera(e) {
    console.log('changeDeviceCamera')
    console.log(e.target.value)
  }

  // Replace Track
  changeDeviceInput(constraints, type) {
    try {
      try {
        if (this.localStream) {
          const tracks =  this.localStream.getTracks()
          tracks.forEach(function (track) { track.stop() })
          this.localStream = null  
        }
      } catch(e) {}
      navigator.mediaDevices.getUserMedia(constraints)
      .then((stream) => {
        try {
          let videoTrack = stream.getVideoTracks()[0]
          let audioTrack = stream.getAudioTracks()[0]
          if (videoTrack) {
            let sender = this.rtcPeerConnection.getSenders().find(function(s) {
              return s.track.kind == videoTrack.kind
            })
            sender.replaceTrack(videoTrack);
            console.log('found sender:', sender);
          }
          if (audioTrack) {
            let sender2 = this.rtcPeerConnection.getSenders().find(function(s) {
              return s.track.kind == audioTrack.kind
            })
            sender2.replaceTrack(audioTrack);
            console.log('found sender2:', sender2);
          }
        
          this.localStream = stream;
          if (type === 'audio') {
            this.localAudioComponent.srcObject = stream  
          } else {
            this.localVideoComponent.srcObject = stream  
          }
        } catch(e) {
          console.log(e)
        }
      })
    } catch(e2) {}  
  }

  handleClickOutside(e) {
    if (e.target && e.target.className && this.state.flagShowSetting) {
      if (['device-setting', 'device-setting-label', 'device-setting-select'].indexOf(e.target.className) === -1) {
        this.setState({
          flagShowSetting: false
        })
      }
    }
  }

  showDeviceSetting() {
    let flagShowSetting = this.state.flagShowSetting
    this.setState({
      flagShowSetting: !flagShowSetting
    })
  }

  onClickCloseSetting() {
    this.setState({
      flagShowSetting: false
    })
  }

  previewGetStatsResult(peer, result) {
    // if(STOP_GETSTATS) {
    //     result.nomore();
    //     return;
    // }

    if (result.connectionType.remote.candidateType.indexOf('relayed') !== -1) {
      result.connectionType.remote.candidateType = 'TURN';
    }
    else {
      result.connectionType.remote.candidateType = 'STUN';
    }

    if (result.connectionType.local.candidateType.indexOf('relayed') !== -1) {
      result.connectionType.local.candidateType = 'TURN';
    }
    else {
      result.connectionType.local.candidateType = 'STUN';
    }


    let remote = {
      remoteIceType: result.connectionType.remote.candidateType,
      externalIPAddressRemote: result.connectionType.remote.ipAddress.join(', '),
      remoteTransport: result.connectionType.remote.transport.join(', '),
      encryptedAs: result.encryption,
      videoResolutionsForReceivers: result.resolutions.recv.width + 'x' + result.resolutions.recv.height,
      totalDataForReceivers: this.bytesToSize(result.audio.bytesReceived + result.video.bytesReceived),
      codecsRecv: result.audio.recv.codecs.concat(result.video.recv.codecs).join(', '),
      bandwidthSpeed: this.bytesToSize(result.bandwidth.speed),
      framerateMean: this.bytesToSize(result.video.send.framerateMean),
      bitrateMean: this.bytesToSize(result.video.send.bitrateMean),
      audiolatency: result.audio.latency + 'ms',
      videolatency: result.video.latency + 'ms',
      audiopacketsLost: result.audio.packetsLost,
      videopacketsLost: result.video.packetsLost

    }

    let local = {
      localIceType: result.connectionType.local.candidateType,
      externalIPAddressLocal: result.connectionType.local.ipAddress.join(', '),
      localTransport: result.connectionType.local.transport.join(', '),
      encryptedAs: result.encryption,
      videoResolutionsForSenders: result.resolutions.send.width + 'x' + result.resolutions.send.height,
      totalDataForSenders: this.bytesToSize(result.audio.bytesSent + result.video.bytesSent),
      codecsSend: result.audio.send.codecs.concat(result.video.send.codecs).join(', '),
      bandwidthSpeed: this.bytesToSize(result.bandwidth.speed),
      framerateMean: this.bytesToSize(result.video.send.framerateMean),
      bitrateMean: this.bytesToSize(result.video.send.bitrateMean),
      audiolatency: result.audio.latency + 'ms',
      videolatency: result.video.latency + 'ms',
      audiopacketsLost: result.audio.packetsLost,
      videopacketsLost: result.video.packetsLost
    }

    this.setState({ localStream: local, remoteStream: remote })

  }

  bytesToSize(bytes) {
    var k = 1000;
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes <= 0) {
      return '0 Bytes';
    }
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(k)), 10);

    if (!sizes[i]) {
      return '0 Bytes';
    }

    return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i];
  }

  showCallTrouble() {

    // Your web app's Firebase configuration
    const firebaseConfig = {
      apiKey: "AIzaSyCmlqZOK-gNXW-b8lIX_gNJCXC86nzj7uw",
      authDomain: "reportcall-a562b.firebaseapp.com",
      databaseURL: "https://reportcall-a562b-default-rtdb.asia-southeast1.firebasedatabase.app",
      projectId: "reportcall-a562b",
      storageBucket: "reportcall-a562b.appspot.com",
      messagingSenderId: "760021342191",
      appId: "1:760021342191:web:8ee67eacb83d514f0c881a"
    }

    let { localStream, remoteStream } = this.state

    this.setState({ showCallTrouble: !this.state.showCallTrouble }, () => {
      // if (this.flagSendFirebase && this.state.flagStartCall) {
        const app = initializeApp(firebaseConfig)
        let postId = Math.floor(Date.now() / 1000)
        const database = getDatabase(app)

        set(ref(database, 'reports/' + postId), {
          localStream: localStream,
          remoteStream: remoteStream,
          callee_uin: this.userid.toString(),
          call_id: rxaget(this.callObj, 'call_id', ''),
          group_id: rxaget(this.callObj, 'group_id', ''),
          call_type: rxaget(this.callObj, 'call_type', ''),
          callee_uins: rxaget(this.callObj, 'callee_uins', ''),
          media_type: rxaget(this.callObj, 'media_type', ''),
        })
      // }
      // this.flagSendFirebase = false;

    })

  }

  render() {
    return this.renderComponent()
  }
}

const mapStateToProps = (state, ownProps) => ({
  themeValue: state.themeValue,
  langValue: state.langValue,
  rxgroup: state.rxgroup,
  user: state.user,
  netaauth: state.netaauth,
  netaCallHistory: state.netaCallHistory,
  netaCall: state.netaCall
})

const mapDispatchToProps = {
  netaCallHistoryUpdate,  
  changeStatusTabmore
}

const CallContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CallScreenComponent_)

export default CallContainer
